var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02228 3C5.85259 3 4.09326 4.77009 4.09326 6.92902V18.5593C4.09326 19.4663 4.42467 20.2934 5.15457 20.7233C5.8839 21.1528 6.76845 21.0427 7.56344 20.605L7.56578 20.6037L11.595 18.3661C11.6727 18.3228 11.8211 18.2807 12.0081 18.2807C12.1958 18.2807 12.3391 18.3231 12.4095 18.3631L16.4433 20.6032C17.2376 21.0456 18.1238 21.1604 18.8553 20.7295C19.5865 20.2989 19.9167 19.4684 19.9167 18.5593L19.9167 6.92902L19.9166 6.92552C19.9065 4.77001 18.1497 3 15.9794 3H8.02228ZM8.02228 4.48576C6.67566 4.48576 5.57903 5.58815 5.57903 6.92902V18.5593C5.57903 19.138 5.78002 19.3674 5.90856 19.4431C6.03757 19.5191 6.33716 19.5837 6.84563 19.3041L6.84679 19.3035L10.8714 17.0685C11.2228 16.8726 11.6359 16.7949 12.0081 16.7949C12.3783 16.7949 12.7905 16.8717 13.1403 17.0695L17.1655 19.3048C17.6754 19.5888 17.9745 19.524 18.1014 19.4493C18.2286 19.3743 18.4309 19.1441 18.4309 18.5593V6.93084C18.4236 5.58732 17.3248 4.48576 15.9794 4.48576H8.02228Z",
    fill: "#0F1653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19434 10.8828C9.19434 10.4725 9.52694 10.1399 9.93722 10.1399H14.0643C14.4746 10.1399 14.8072 10.4725 14.8072 10.8828C14.8072 11.2931 14.4746 11.6257 14.0643 11.6257H9.93722C9.52694 11.6257 9.19434 11.2931 9.19434 10.8828Z",
    fill: "#0F1653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0007 8.12592C12.411 8.12592 12.7436 8.45852 12.7436 8.8688V12.9959C12.7436 13.4062 12.411 13.7388 12.0007 13.7388C11.5904 13.7388 11.2578 13.4062 11.2578 12.9959V8.8688C11.2578 8.45852 11.5904 8.12592 12.0007 8.12592Z",
    fill: "#0F1653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.7b83c0c9120ccab520d9507f70ffca06.svg";
export { ForwardRef as ReactComponent };